import { Stack, Typography } from '@mui/material';
import React from 'react';
import { PurchaseConditionNew } from '@retail/calculus/types';
import { useAppTFunction } from '@retail/app/i18n';
import { getClassCodeLabel } from '@retail/products/utils';

interface Props {
  purchaseCondition: PurchaseConditionNew;
}

export const PurchaseConditionInfo = ({ purchaseCondition }: Props) => {
  const t = useAppTFunction();
  return (
    <Stack>
      <Stack direction="row" gap={1} alignItems="center">
        <Typography variant="body2" fontWeight="bold">
          {purchaseCondition.agreementText ?? purchaseCondition.agreementNumber}
        </Typography>
      </Stack>
      {purchaseCondition.packageType && (
        <Typography variant="body3">{getClassCodeLabel(purchaseCondition.packageType)}</Typography>
      )}
    </Stack>
  );
};
